const distanceBetweenPoints = (p1, p2, seperator, name) => {
  const lat1 = p1?.[name?.x]
  const lon1 = p1?.[name?.y]

  const lat2 = p2?.[seperator]?.[name?.x]
  const lon2 = p2?.[seperator]?.[name?.y]

  const R = 6371
  const dLat = deg2rad(lat2 - lat1)
  const dLon = deg2rad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c // Distance in km

  return calcMilesFromKilometers(d)
}

const deg2rad = (deg) => {
  return deg * (Math.PI / 180)
}

const calcMilesFromKilometers = (km) => {
  return km * 0.621371
}

export const sortByDistance = (origin, points, opts) => {
  opts = opts || {}

  if (!origin || !points) {
    return new Error('An origin and array points must be provided')
  }

  const names = {
    y: opts?.yName || 'y',
    x: opts?.xName || 'x',
  }

  const newPoints = JSON.parse(JSON.stringify(points))

  newPoints.sort((a, b) => {
    a.distance = distanceBetweenPoints(origin, a, opts?.seperator, names)
    b.distance = distanceBetweenPoints(origin, b, opts?.seperator, names)

    return a?.distance - b?.distance
  })

  return newPoints
}

export const getBrowserLocation = () => {
  return new Promise((resolve, reject) => {
    const success = (position) => {
      const coords = {
        lat: position?.coords?.latitude,
        lng: position?.coords?.longitude,
      }
      resolve(coords)
    }

    const error = (err) => {
      reject(err)
    }

    if (navigator?.geolocation) {
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
      return navigator.geolocation?.getCurrentPosition(success, error, options)
    } else {
      reject(error)
    }
  })
}
